import React, { Fragment, memo, useState, useEffect,useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faPlus, faPencilAlt, faTrash,faListAlt } from '@fortawesome/free-solid-svg-icons';
import { SiteRutas } from '../../../request/RutasConfig.jsx';
import Lista from '../../../components/UI/controlLista/controlLista.jsx';
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';
//Invocaciones datos
import { Corporacion_Listar_Request, Corporacion_Eliminar_Request } from "../../../request/MantenimientosRequest.jsx"

import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';
import Swal from 'sweetalert2';
import ModalCorporaciones from './modalCorporaciones.jsx';

//Seguridad
import Session from '../../../components/Util/session/index.jsx';
import Config from '../../../components/Util/constantes.js';
import {Obtener_MenuOpciones_Lista_Request,Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx"
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../../components/Util/seg-menu-opciones.js';


function listaCorporaciones(props){
    const [borrando, setBorrando] = useState(false);
    const [datos, setDatos] = useState([]);
    const [id, setID] = useState(0);
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const mounted = useRef();
    const [spinnerModal, setSpinnerModal] = useState(undefined);
    const [spinnerLabel, setSpinnerLabel] = useState('');
    const [spinnerTipo, setSpinnerTipo] = useState(1);
    let historyMenu = useHistory();

    const columnas = [{
        dataField: 'Id',
        text: 'Código',
        csvText: 'codigo',
        sort: true
    }, {
        dataField: 'Nombre',
        text: 'Nombre',
        csvText: 'Nombre',
        sort: true
    }]
    const botones = [
        {
            name: "btnHomeC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => volverAtras(),
            leyenda: "",
            iclase: faReply,
            tooltip: "Volver"
        },
        {
            name: "btnModificarC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => actualizarDatos(),
            leyenda: "",
            iclase: faPencilAlt,//"fa fa-pencil",
            tooltip: "Modificar"
        },
        {
            name: "btnNuevoC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => ingresarDatos(),
            leyenda: "",
            iclase: faPlus,//"fa fa-plus",
            tooltip: "Agregar nuevo"
        },
        {
            name: "btnDeleteC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleBorrar(),
            leyenda: "",
            iclase: faTrash,
            tooltip: "Eliminar"
        },
        {
            name: "btnDetalleCorp",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => detalleDatos(),
            leyenda: "",
            iclase: faListAlt,
            tooltip: "Ver Detalle"
        }
        
    ]

//modal
const [selectModalDet, setSelectModalDet] = useState(false);
const botonesModDet = [
    {
      name: "btnHomeC",
      clase: "btn btn-sm pull-right flipInX animated",
      evento: () => cerrarModalDetCorp(false),
      leyenda: "",
      iclase: faReply,
      tooltip: "Volver"
    }
  ]

  const listaCampos = {
    Id: { value: 0, attributes: { readOnly: true, focus: false, label: 'Identificador', hidden: 'unset', Editando: false, maxLength: "20" } },
    Nombre: { value: "", attributes: { readOnly: false, focus: false, label: 'Nombre', hidden: 'unset', Editando: false, maxLength: "120" } },
    Direccion: { value: "", attributes: { readOnly: false, focus: false, label: 'Dirección', hidden: 'unset', Editando: false, maxLength: "255" } },
    Email: { value: "", attributes: { readOnly: false, focus: false, label: 'Correo Electrónico', hidden: 'unset', Editando: false, maxLength: "100" } },
    Fax: { value: "", attributes: { readOnly: false, focus: false, label: 'Fax', hidden: 'unset', Editando: false, maxLength: "15" } },
    Telefono: { value: "", attributes: { readOnly: false, focus: false, label: 'Teléfono', hidden: 'unset', Editando: false, maxLength: "15" } },
    Site: { value: "", attributes: { readOnly: false, focus: false, label: 'Sitio Web', hidden: 'unset', Editando: false, maxLength: "30" } },
    CedulaJuridica: { value: "", attributes: { readOnly: false, focus: false, label: 'Cédula Jurídica', hidden: 'unset', Editando: false, maxLength: "25" } },
  }
  const [datosDet, setDatosDet] = useState(listaCampos);
    //Seguridad
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
    const [menuId,setMenuId] = useState(0);
    const [menuOpciones,setMenuOpciones] = useState([]);
    const [showModalSeguridad, setShowModalSeguridad ] = useState(false);
    const [opcionValidar, setOpcionValidar ] = useState(0);
    const [opcionValidarNombre, setOpcionValidarNombre ] = useState('');



    const selectRow = { mode: 'radio', clickToSelect: true, hideSelectColumn: true, onSelect: (row, isSelected) => onRowSelect(row, isSelected), bgColor: '#d73220' };
    const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
        setSpinnerModal(pSpinnerModal);
        setSpinnerLabel(pSpinnerLabel);
        setSpinnerTipo(pSpinnerTipo);
    }

    const actualizarDatos = () => {
        if (validaSeleccionado()) {
            historyMenu.push(`${SiteRutas.MantCorporaciones}/${id}`);                    
        }
    }

    const ingresarDatos = () => {
        let _id = '0'
        historyMenu.push(`${SiteRutas.MantCorporaciones}/${_id}`);        
    }

    const volverAtras = () => {
        historyMenu.push(SiteRutas.Asientos);        
    }
    //Valida que se haya seleccionado un dato
    const validaSeleccionado = () => {
        let _id = id;
        if (_id != '') {
            return true;
        }
        else {
            Notificacion.error('Debe seleccionar un registro.');
            return false;
        }
    }
    const onRowSelect = (row, isSelected) => {
        setID(row.Id);
        const _LD = asociarDatos(row);
        setDatosDet(_LD)
    }
    const onDoubleClick = (e, row, rowIndex) => {
        actualizarDatos();
    }

    const cargarDatos = async (pBorrando) => {
        if (!pBorrando) {
            let spinnerLabel = 'Cargando datos...';
            spinnerModalMostrar(true, spinnerLabel, 3)
        }
        const response = await Corporacion_Listar_Request(token);
        if (response.Exitoso) {            
            setDatos(response.Datos);
        }
        else {
            Notificacion.error(response.Mensaje);
            spinnerModalMostrar(false, '', 3);            
        }
        if (!pBorrando) {
            spinnerModalMostrar(false, '', 3)
        }


         const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.Corporacion.value);
         let _menuId = 0
         if (_MenuNomb.ID != undefined) {
             _menuId = _MenuNomb.ID;
         }
         const _UsuarioS = usuarioS;
         let _menuOpciones = null;
         if (_menuId > 0) {
              _menuOpciones = await cargarMenuOpciones( Config.Modulo ,_UsuarioS, _menuId);
         }
         setMenuId(_menuId), setMenuOpciones(_menuOpciones)
    }



    const handleBorrar = () => {
        if (validaSeleccionado()) {
            const optSegopt = optSeg.TOpciones_Menu;
            let validar = validarMenuOpcion(optSegopt.Eliminar.value);
            if (!validar) {
                handleBorrarSel();
            }
        }
    }

    const handleBorrarSel = () => {
        let resultado = false;

        if (validaSeleccionado()) {

            Swal.fire({
                title: 'Eliminar Categorías',
                html: '<h4>¿Está seguro que desea eliminar la corporación"?</h4>',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#10a599',
                cancelButtonColor: '#d33',
                confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
                cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    resultado = true;
                    borrarDatos();
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    resultado = false;
                }
            })
            setBorrando(false);
        }

        return resultado;
    }

    const detalleDatos = () => {
        if (validaSeleccionado()) {
            const optSegopt = optSeg.TOpciones_Menu;
            let validar = validarMenuOpcion(optSegopt.VerDetalle.value);
            if (!validar) {
                handleDetalleCorp();
            }
        }
    }

    const handleDetalleCorp = () => {
        let resultado = false;

        if (validaSeleccionado()) {
            setSelectModalDet(true);
        }

    }

    const borrarDatos = async () => {
        let _id = id;
        let resultado = '';
        spinnerModalMostrar(true, 'Eliminando', 3);
        resultado = await Corporacion_Eliminar_Request(token, _id, usuario);
        if (resultado.Exitoso) {
            Notificacion.success(`Se eliminó con éxito.`);
            setBorrando(true);
            await cargarDatos(true);                
            setID('');

        }
        else {
            Notificacion.error(`Error: ${resultado.Mensaje}`);
        }

        spinnerModalMostrar(false, '', 3);

    }

    useEffect(() => {

        if (!mounted.current) {
            const carga = async () => {
                await cargarDatos()
            }
            carga();
            mounted.current = true;
        }
    }, [])

    
    //Seguridad
    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {

            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    }

    const cargarMenuNombre = async (pModulo,pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token,pModulo,pMenuNombre);
            if (listMON.Exitoso == false) {
              return  null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    }

    const validarMenuOpcion = (pOpcion) => {
        let validar = false;
        let _menuOpciones = menuOpciones;
        const optSegopt = optSeg.TOpciones_Menu;
        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;            
        }
        return validar;
    };

    const handleCerrarModal = () => setShowModalSeguridad(false);

    const onActionResultModal = (pValido) => {        
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;            
            switch (_OpcionNom) {
                case _optSegopt.Eliminar.value:
                    handleBorrarSel();
                    break;
                case _optSegopt.VerDetalle.value:
                    handleDetalleCorp();
                    break;                    
                default:
                    break;
            }
        }
    }

// modal detalle

const cerrarModalDetCorp = (pEstado) => {
    setSelectModalDet(pEstado);
  }

  const asociarDatos = (pDatos) => {
    let _Campos = listaCampos;
    _Campos.Id.value = pDatos.Id;
    _Campos.Nombre.value = pDatos.Nombre;
    _Campos.Direccion.value = pDatos.Direccion;
    _Campos.Email.value = pDatos.Email;
    _Campos.Fax.value = pDatos.Fax;
    _Campos.Telefono.value = pDatos.Telefono;
    _Campos.Site.value = pDatos.Site;
    _Campos.CedulaJuridica.value = pDatos.CedulaJuridica;
    return _Campos;
}

    return (
        <Fragment>
            <Lista
                titulo={'Lista de Corporaciones'}
                id={"Id"}
                datos={datos}
                columnas={columnas}
                selectRow={selectRow}
                onDoubleClick={onDoubleClick}
                borrando={borrando}
                botones={botones}
                verLHOC={false}
                nombreCSV={"Corporaciones"}
            />
            <ModalSpinner
                selectedModal={spinnerModal}
                contentLabel={'spinnerModalProgress'}
                label={spinnerLabel}
                tipoSpinner={spinnerTipo}
            />
            <ModalSeguridad
            modalTitle={'Requiere Permisos'}
            menuId={menuId}
            opcionId={opcionValidar}
            show={showModalSeguridad}
            onActionResult={onActionResultModal}
            onHide={handleCerrarModal}
            />
            <ModalCorporaciones 
            show={selectModalDet}
            titulo={'Detalle de Corporación'}
            Datos={datosDet}
            botones={botonesModDet}
            cerrarModal={cerrarModalDetCorp}
            />
              
        </Fragment>
    );
};
export default withRouter(memo(listaCorporaciones))
